import { SupportMetadataAdminPage as PlatformSupportMetadataAdminPage } from '@jarvis/platform-ui';
import { siteFeedbackApi } from '../../../siteSupport/config';

export function SupportMetadataAdminPage() {
  return <PlatformSupportMetadataAdminPage api={siteFeedbackApi} />;
}
